import { Typography } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

const StyledTitle = styled(Typography)`
  font-size: 1.125rem;
  margin-bottom: 0.75rem;
  font-weight: 600;
  color: #002740;
`;

interface IFormSectionTitleProps {
  title: string;
}

const FormSectionTitle = (props: IFormSectionTitleProps) => {
  const { title } = props;
  return <StyledTitle>{title}</StyledTitle>;
};

export default FormSectionTitle;
